module.exports = __webpack_public_path__ + "img/menuNew.96765abb.jpg";